import { render, staticRenderFns } from "./GeneralEntrance_mobile.vue?vue&type=template&id=17395070&scoped=true"
import script from "./GeneralEntrance_mobile.vue?vue&type=script&lang=js"
export * from "./GeneralEntrance_mobile.vue?vue&type=script&lang=js"
import style0 from "./GeneralEntrance_mobile.vue?vue&type=style&index=0&id=17395070&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17395070",
  null
  
)

export default component.exports